import { ImgixParams, buildURL } from 'react-imgix';

import { MediaRefFragment } from '$/GraphQL/schema/types';

import { fixedFloat } from './number';
import { isFromDomain } from '$/shared/frontend/utils/string';

export function getImgixCropParams(
  ref: MediaRefFragment | null | undefined,
  imgixParams: Partial<ImgixParams>
): ImgixParams {
  const params: ImgixParams = { dpr: 2, ...imgixParams };

  if (ref?.crop && ref?.width && ref?.height) {
    const [x, y, w, h] = ref.crop;

    // Calculate the focal point (center) of the cropped area
    params.fit = 'crop';
    params.crop = 'focalpoint';
    params['fp-x'] = fixedFloat(x + w / 2);
    params['fp-y'] = fixedFloat(y + h / 2);
    params['fp-z'] = fixedFloat(Math.min(1 / w, 1 / h));
  }

  return params;
}

export function getImageSrcFromRef(
  ref: MediaRefFragment | null | undefined,
  imgParams: Partial<ImgixParams>
): string | undefined {
  const imgixParams = getImgixCropParams(ref, imgParams);

  if (!ref || !ref.imageUrl) return undefined;

  let cleanUrl = ref.imageUrl;

  if (cleanUrl?.startsWith('data:')) {
    return cleanUrl;
  }

  if (isFromDomain(ref.imageUrl, 'imgix.net')) {
    cleanUrl = ref.imageUrl?.split('?')[0];
  }

  const url = buildURL(cleanUrl, imgixParams);
  return url;
}
